import script from "./AgentFab.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentFab.vue?vue&type=script&setup=true&lang=js"

import "./AgentFab.vue?vue&type=style&index=0&id=2f5aedc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f5aedc2"]])

export default __exports__